export { default as DE } from "./de.json";
export const PRIVACY_NAMESPACE = "privacy";
